export default __webpack_public_path__ + "static/media/backgroundVideocall.cce099a2.png";